import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DEFINITION_MAX_LENGTH, DOC_TYPES } from '../../../screening/screening.constants';
import { AppState } from 'src/app/app.state';
import { Store, ActionsSubject } from '@ngrx/store';
import { selectAllPhases, selectDADeliverableTemplateForm,
  selectSMEDisciplineConfigCodes 
} from '../../store/global-settings.selectors';
import { clearDADeliverableTemplateForm,
  createDADeliverableTemplateFromForm,
  createDADeliverableTemplateFromFormSuccess,
  loadAllPhases,
  loadDADeliverableTemplate,
  loadSMEDisciplineConfigCodes,
  updateDADeliverableTemplateForm,
  updateDADeliverableTemplateFormSuccess 
} from '../../store/global-settings.actions';
import { filter, Subscription } from 'rxjs';

@Component({
  standalone: false,
  selector: 'app-deliverable-template-form-dialog',
  templateUrl: './deliverable-template-form-dialog.component.html',
  styleUrl: './deliverable-template-form-dialog.component.scss',
})
export class DeliverableTemplateFormDialogComponent {
  private readonly subscriptions = new Subscription();
  formState$ = this.store.select(selectDADeliverableTemplateForm);
  smeDisciplineConfigCodes$ = this.store.select(selectSMEDisciplineConfigCodes);
  phases$ = this.store.select(selectAllPhases);
  readonly daDeliverableTemplateId?: string;
  readonly DEFINITION_MAX_LENGTH = DEFINITION_MAX_LENGTH;
  readonly docTypes = DOC_TYPES;
  readonly title: string = '';

  constructor(
    private store: Store<AppState>,
    private actionsSubject$: ActionsSubject,
    private dialogRef: MatDialogRef<DeliverableTemplateFormDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: string
  ) {
    this.store.dispatch(loadSMEDisciplineConfigCodes());
    this.store.dispatch(loadAllPhases());
    this.daDeliverableTemplateId = data;
        if (this.daDeliverableTemplateId) {
          this.store.dispatch(
            loadDADeliverableTemplate({
              daDeliverableTemplateId: this.daDeliverableTemplateId,
            })
          );
          this.title = 'edit DA deliverable template';
        } else {
          this.store.dispatch(clearDADeliverableTemplateForm());
          this.title = 'add DA deliverable template';
        }
  }
  
  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  closeWindow(): void {
    this.dialogRef.close();
  }

  save() {
    this.daDeliverableTemplateId ? this.update() : this.create();
  }

  private update() {
      this.registerActionSuccess(updateDADeliverableTemplateFormSuccess.type);
      this.store.dispatch(
        updateDADeliverableTemplateForm({
          daDeliverableTemplateId: this.daDeliverableTemplateId!,
        })
      );
    }
  
    private create() {
      this.registerActionSuccess(
        createDADeliverableTemplateFromFormSuccess.type
      );
      this.store.dispatch(createDADeliverableTemplateFromForm());
    }

    private registerActionSuccess(actionType: string) {
        this.subscriptions.add(
          this.actionsSubject$
            .pipe(filter((action) => action.type === actionType))
            .subscribe(() => {
              this.dialogRef.close();
            })
        );
      }
}
